import get from 'lodash/get'

// Modal

export const isModalActive = (state) => get(state, 'userInteractions.modal.isActive')
export const currentModalId = (state) => get(state, 'userInteractions.modal.currentId')

// Confirm Modal

export const confirmModalContent = (state) => get(state, 'userInteractions.confirmModalContent')
export const confirmModalIsOpen = (state) =>
  get(state, 'userInteractions.confirmModalIsOpen', false)

// Error Modal

export const errorCode = (state) => get(state, 'userInteractions.errorCode')
export const errorModalIsVisible = (state) => !!errorCode(state)

// Password Reset

export const passwordResetRequestFormIsVisible = (state) =>
  get(state, 'userInteractions.passwordResetRequestFormIsVisible', false)
export const passwordResetRequestSuccessIsVisible = (state) =>
  get(state, 'userInteractions.passwordResetRequestSuccessIsVisible', false)
